// CurrencyField.tsx
import {useState, FC} from 'react';
import {Field} from 'formik';
import {InputAdornment} from '@mui/material';
import {currencyFormatter} from '@/utils/helpers/currency';
import Input from '../Input';

interface CurrencyFieldProps {
  name: string;
//   label: string;
  label?: React.ReactNode;
  placeholder?: string;
  sx?: any;
  disabled?: boolean;
  startAdornment?: React.ReactNode;
  isArrayData?: boolean;
}

const CurrencyField: FC<CurrencyFieldProps> = ({
  name,
  label,
  placeholder,
  sx,
  disabled,
  startAdornment,
  isArrayData,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [rawInput, setRawInput] = useState<string | null>(null);

  return (
    <Field name={name} isArrayData={isArrayData}>
      {({field, form}: any) => {
        const value = field.value;

        const displayValue = isFocused
          ? rawInput ?? (value !== undefined && value !== null ? String(value) : '')
          : value !== undefined && value !== null
          ? currencyFormatter.format(value)
          : '';

        return (
          <Input
            field={field}
            form={form}
            id={name}
            name={name}
            label={label}
            placeholder={placeholder}
            sx={sx}
            disabled={disabled}
            type="text"
            inputMode="decimal"
            isArrayData={isArrayData}
            value={displayValue}
            onFocus={() => {
              setIsFocused(true);
              setRawInput(value !== undefined && value !== null ? String(value) : '');
            }}
            onBlur={() => {
              setIsFocused(false);
              setRawInput(null);
            }}
            onChange={(val: string) => {
              let raw = val.replace(/[^0-9.]/g, '');
              const firstDotIndex = raw.indexOf('.');
              if (firstDotIndex !== -1) {
                raw = raw.slice(0, firstDotIndex + 1) + raw.slice(firstDotIndex + 1).replace(/\./g, '');
              }
              setRawInput(raw);
              form.setFieldValue(name, raw === '' || raw === '.' ? undefined : Number(raw));
            }}
            InputProps={{
              startAdornment: startAdornment ? (
                <InputAdornment position="start">{startAdornment}</InputAdornment>
              ) : undefined,
            }}
          />
        );
      }}
    </Field>
  );
};

export default CurrencyField;
